<template>
    <div>

        <vue-headful title="Safety Meetings :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-life-ring"></i> Safety Meetings</li>
                <li class="ml-3">
                    <router-link :to="`/safety-meetings/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
                </li>
            </ol>
        </h4>

        <saved-filter-title :filterKey="'meetingFilters'" />

        <div class="card">
            <div class="card-body">
                <safety-meeting-list ref="safetyMeetingIndexList" :allowFilterSaving="true" :filterId="(filter_id ? parseInt(filter_id) : null)" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
            }
        },

        computed: {
            appliedFilter(){
                return this.$store.state.appliedFilter;
            }
        },

        methods: {
            setUpdateFilter(){
                //Set it
                this.$store.commit('setUpdateFilter', true);
            },

            setDeleteFilter(){
                //Set it
                this.$store.commit('setDeleteFilter', true);
            },

            removeFilter(){
                //Clear the filters?
                this.$refs.safetyMeetingIndexList.filtersCleared();

                //Set it
                this.$router.push('/safety-meetings');
            }
        },

        mounted(){
            //Focus on the SEarch Input
            this.$refs.safetyMeetingIndexList.$refs.safetyMeetingTable.$refs.genericFilter.focus();
        },
    }
</script>
